/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Timeline_LaterInputs */

const id_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const ms_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const da_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const de_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const en_us2_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const es_es2_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posteriores`)
};

const es_mx2_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posterior`)
};

const fil_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const fr_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const it_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const hu_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const nl_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const no_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const pl_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const pt_br2_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const pt_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const ro_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const fi_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const sv_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const vi_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const tr_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const cs_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const bg_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const ru_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позже`)
};

const uk_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const ar_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const hi_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाद में`)
};

const th_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ภายหลัง`)
};

const ja_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const zh_cn2_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const zh_hant1_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`較晚`)
};

const ko_builds_timeline_later = /** @type {(inputs: Builds_Timeline_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

/**
* | output |
* | --- |
* | "Later" |
*
* @param {Builds_Timeline_LaterInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_timeline_later = /** @type {((inputs?: Builds_Timeline_LaterInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Timeline_LaterInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_timeline_later(inputs)
	if (locale === "ms") return ms_builds_timeline_later(inputs)
	if (locale === "da") return da_builds_timeline_later(inputs)
	if (locale === "de") return de_builds_timeline_later(inputs)
	if (locale === "en-US") return en_us2_builds_timeline_later(inputs)
	if (locale === "es-ES") return es_es2_builds_timeline_later(inputs)
	if (locale === "es-MX") return es_mx2_builds_timeline_later(inputs)
	if (locale === "fil") return fil_builds_timeline_later(inputs)
	if (locale === "fr") return fr_builds_timeline_later(inputs)
	if (locale === "it") return it_builds_timeline_later(inputs)
	if (locale === "hu") return hu_builds_timeline_later(inputs)
	if (locale === "nl") return nl_builds_timeline_later(inputs)
	if (locale === "no") return no_builds_timeline_later(inputs)
	if (locale === "pl") return pl_builds_timeline_later(inputs)
	if (locale === "pt-BR") return pt_br2_builds_timeline_later(inputs)
	if (locale === "pt") return pt_builds_timeline_later(inputs)
	if (locale === "ro") return ro_builds_timeline_later(inputs)
	if (locale === "fi") return fi_builds_timeline_later(inputs)
	if (locale === "sv") return sv_builds_timeline_later(inputs)
	if (locale === "vi") return vi_builds_timeline_later(inputs)
	if (locale === "tr") return tr_builds_timeline_later(inputs)
	if (locale === "cs") return cs_builds_timeline_later(inputs)
	if (locale === "bg") return bg_builds_timeline_later(inputs)
	if (locale === "ru") return ru_builds_timeline_later(inputs)
	if (locale === "uk") return uk_builds_timeline_later(inputs)
	if (locale === "ar") return ar_builds_timeline_later(inputs)
	if (locale === "hi") return hi_builds_timeline_later(inputs)
	if (locale === "th") return th_builds_timeline_later(inputs)
	if (locale === "ja") return ja_builds_timeline_later(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_timeline_later(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_timeline_later(inputs)
	return ko_builds_timeline_later(inputs)
});
export { builds_timeline_later as "builds.timeline.later" }